export default "__VITE_ASSET__BQb6Bc8h__"